import * as React from "react";
import { SvgIcon, SvgIconProps } from "@origin-digital/ods-icons";

export const StopIcon = () => (
  <SvgIcon titleAccess="OCP projects stop">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8995 4C15.1647 4 15.4191 4.10536 15.6066 4.29289L19.7071 8.3934C19.8946 8.58094 20 8.83529 20 9.10051L20 14.8995C20 15.1647 19.8946 15.4191 19.7071 15.6066L15.6066 19.7071C15.4191 19.8946 15.1647 20 14.8995 20H9.1005C8.83529 20 8.58093 19.8946 8.3934 19.7071L4.29289 15.6066C4.10536 15.4191 4 15.1647 4 14.8995V9.10041C4 8.83525 4.10531 8.58095 4.29278 8.39342L8.3919 4.293C8.57944 4.1054 8.83385 4 9.09912 4H14.8995ZM7.58789 10.3762C7.03561 10.3762 6.58789 10.8239 6.58789 11.3762V12.6235C6.58789 13.1758 7.03561 13.6235 7.58789 13.6235H16.4121C16.9644 13.6235 17.4121 13.1758 17.4121 12.6235V11.3762C17.4121 10.8239 16.9644 10.3762 16.4121 10.3762H7.58789Z"
      fill="#EC0000"
    />
  </SvgIcon>
);

export const ArchiveIcon = () => (
  <SvgIcon titleAccess="OCP projects archive">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4C3.44772 4 3 4.44772 3 5V9C3 9.55228 3.44772 10 4 10L4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V10C20.5523 10 21 9.55228 21 9V5C21 4.44772 20.5523 4 20 4H4ZM19 8H5V6H19V8ZM6 18V10H18V18H6ZM10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H10Z"
      fill="#737373"
    />
  </SvgIcon>
);

export const PlayIcon = () => (
  <SvgIcon titleAccess="OCP projects play">
    <path
      d="M6.5 5.78233C6.5 5.00154 7.35483 4.52195 8.02119 4.92889L18.2025 11.1465C18.8409 11.5363 18.8409 12.4635 18.2025 12.8534L8.02119 19.0709C7.35483 19.4779 6.5 18.9983 6.5 18.2175V5.78233Z"
      fill="#0A5FD2"
    />
  </SvgIcon>
);

export const FolderIcon = () => (
  <SvgIcon titleAccess="OCP projects folder">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3C8.44772 3 8 3.44772 8 4V6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H16V4C16 3.44772 15.5523 3 15 3H9ZM10 6H14V5H10V6ZM9 8H15H19V11H13H11H5V8H9ZM5 13V18H19V13H14V14C14 14.5523 13.5523 15 13 15H11C10.4477 15 10 14.5523 10 14V13H5Z"
      fill="#505050"
    />
  </SvgIcon>
);

export const DraftsIcon = () => (
  <SvgIcon titleAccess="OCP DraftsIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0104 4.57722C17.6198 4.1867 16.9867 4.1867 16.5962 4.57722L15.1822 5.99115L18.0106 8.81952L16.5964 10.2337L13.768 7.40537L5.28245 15.8909L5.28262 18.7192L8.11088 18.7194L19.4246 7.40565C19.8151 7.01513 19.8151 6.38196 19.4246 5.99144L18.0104 4.57722Z"
        fill="#FFB432"
      />
    </svg>
  </SvgIcon>
);
export const LodgedIcon = () => (
  <SvgIcon titleAccess="OCP LodgedIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 5.78233C6.5 5.00154 7.35483 4.52195 8.02119 4.92889L18.2025 11.1465C18.8409 11.5363 18.8409 12.4635 18.2025 12.8534L8.02119 19.0709C7.35483 19.4779 6.5 18.9983 6.5 18.2175V5.78233Z"
        fill="#0A5FD2"
      />
    </svg>
  </SvgIcon>
);

export const StalledIcon = () => (
  <SvgIcon titleAccess="OCP StalledIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8995 4C15.1647 4 15.4191 4.10536 15.6066 4.29289L19.7071 8.3934C19.8946 8.58094 20 8.83529 20 9.10051L20 14.8995C20 15.1647 19.8946 15.4191 19.7071 15.6066L15.6066 19.7071C15.4191 19.8946 15.1647 20 14.8995 20H9.1005C8.83529 20 8.58093 19.8946 8.3934 19.7071L4.29289 15.6066C4.10536 15.4191 4 15.1647 4 14.8995V9.10041C4 8.83525 4.10531 8.58095 4.29278 8.39342L8.3919 4.293C8.57944 4.1054 8.83385 4 9.09912 4H14.8995ZM7.58789 10.3762C7.03561 10.3762 6.58789 10.8239 6.58789 11.3762V12.6235C6.58789 13.1758 7.03561 13.6235 7.58789 13.6235H16.4121C16.9644 13.6235 17.4121 13.1758 17.4121 12.6235V11.3762C17.4121 10.8239 16.9644 10.3762 16.4121 10.3762H7.58789Z"
        fill="#EC0000"
      />
    </svg>
  </SvgIcon>
);
export const TotalIcon = () => (
  <SvgIcon titleAccess="OCP TotalIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L17.2764 4.55279C17.107 4.214 16.7607 4 16.382 4L7.3151 4C6.85534 4 6.63929 4.56826 6.98292 4.8737L14.5796 11.6263C14.8033 11.8252 14.8033 12.1748 14.5796 12.3737L6.98292 19.1263C6.63929 19.4317 6.85534 20 7.3151 20H16.382C16.7607 20 17.107 19.786 17.2764 19.4472L18 18"
        stroke="#505050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const ClosedEnvelopeIcon = () => (
  <SvgIcon titleAccess="OCP ClosedEnvelopeIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7V8.00011V17C3 18.1046 3.80589 19 4.8 19H19.2C20.1941 19 21 18.1046 21 17V8.00011V7C21 5.89543 20.1941 5 19.2 5H4.8C3.80589 5 3 5.89543 3 7ZM12.2236 10.8883L19 7V9.00011L12.4472 12.7765C12.1657 12.9173 11.8343 12.9173 11.5528 12.7765L5 9.00011V7L11.7764 10.8883C11.9172 10.9587 12.0828 10.9587 12.2236 10.8883Z"
        fill="#EC0000"
      />
    </svg>
  </SvgIcon>
);

export const GreenTickIcon = () => (
  <SvgIcon titleAccess="OCP GreenTickIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 10.546 20.6552 9.17263 20.043 7.95702L11.0002 16.9998L6.12016 12.1198C5.72844 11.7281 5.72957 11.0927 6.12267 10.7024C6.51381 10.314 7.14539 10.3151 7.53516 10.7048L11.0002 14.1698L18.9256 6.25191C17.2747 4.26506 14.7851 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="#008906"
      />
    </svg>
  </SvgIcon>
);

export const DoubleArrowIcon = () => (
  <SvgIcon titleAccess="OCP DoubleArrowIcon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.38841 5.29289C6.99788 4.90237 6.36472 4.90237 5.9742 5.29289L3.41421 7.85287L2.01762 9.24947L2 9.26709L5.95744 13.2245C6.34797 13.6151 6.98113 13.6151 7.37166 13.2245C7.76218 12.834 7.76218 12.2008 7.37166 11.8103L5.82147 10.2601H12.0071C12.5594 10.2601 13.0071 9.81242 13.0071 9.26013C13.0071 8.70785 12.5594 8.26013 12.0071 8.26013H5.83538L7.38841 6.70711C7.77893 6.31658 7.77893 5.68342 7.38841 5.29289ZM16.6116 10.7729C17.0021 10.3823 17.6353 10.3823 18.0258 10.7729L20.5858 13.3329L21.9824 14.7294L22 14.7471L18.0426 18.7045C17.652 19.095 17.0189 19.095 16.6283 18.7045C16.2378 18.314 16.2378 17.6808 16.6283 17.2903L18.1785 15.7401H11.9929C11.4406 15.7401 10.9929 15.2924 10.9929 14.7401C10.9929 14.1878 11.4406 13.7401 11.9929 13.7401H18.1646L16.6116 12.1871C16.2211 11.7966 16.2211 11.1634 16.6116 10.7729Z"
        fill="#FA4616"
      />
    </svg>
  </SvgIcon>
);
export const CircleIcon = () => (
  <SvgIcon titleAccess="Not interested" color="critical">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20Zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9Z" />
  </SvgIcon>
);

// Icons from playroom starts here
// Draft Icon
export const DraftIcon = (props?: SvgIconProps) => (
  <SvgIcon titleAccess="Draft" color="primaryB" size="xsmall" {...props}>
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
  </SvgIcon>
);

// Assigned to Collaborator Icon
export const AssignedIcon = () => (
  <SvgIcon titleAccess="Assign to person" color="primaryB" size="xsmall">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1 8a2.1 2.1 0 1 0-4.2 0 2.1 2.1 0 0 0 4.2 0Zm4 9c0-.64-3.13-2.1-6.1-2.1-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17ZM11 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4Zm-4 9c0-2.66 5.33-4 8-4s8 1.34 8 4v2c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-2ZM5.108 9.439V7.536c0-.478.554-.712.873-.382l2.865 2.965a.54.54 0 0 1 0 .755l-2.865 2.965c-.319.34-.873.106-.873-.372v-1.902H2.027c-.565 0-1.027-.479-1.027-1.063 0-.585.462-1.063 1.027-1.063h3.08Z"
    />
  </SvgIcon>
);

// In Progress Icon
export const InProgressIcon = () => (
  <SvgIcon titleAccess="In progress" color="secondary" size="xsmall">
    <path d="M6 5.296v13.408c0 1.022 1.2 1.644 2.125 1.087l11.233-6.704c.856-.505.856-1.67 0-2.187L8.125 4.209C7.201 3.652 6 4.274 6 5.296Z" />
  </SvgIcon>
);

// Connected Icon
export const ConnectedIcon = () => (
  <SvgIcon titleAccess="Book closure" color="info" size="xsmall">
    <path d="m4.659 11.816-3.48 3.546a.66.66 0 0 0 0 .902l3.48 3.546c.388.407 1.064.114 1.064-.445v-2.287h7.523c.689 0 1.252-.572 1.252-1.271 0-.7-.563-1.271-1.252-1.271H5.723V12.26c0-.572-.676-.852-1.064-.445Zm18.164-4.08-3.48-3.546c-.388-.407-1.064-.115-1.064.445V6.91h-7.536c-.689 0-1.252.572-1.252 1.27 0 .7.563 1.272 1.252 1.272h7.523v2.275c0 .572.676.851 1.064.445l3.48-3.546a.632.632 0 0 0 .013-.89Z" />
  </SvgIcon>
);

// Completed Icon
export const CompletedIcon = () => (
  <SvgIcon
    titleAccess="Finished"
    color="positive"
    size="xsmall"
    variant="solid"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2ZM9.29 16.29 5.7 12.7a.996.996 0 1 1 1.41-1.41L10 14.17l6.88-6.88a.996.996 0 1 1 1.41 1.41l-7.59 7.59a.996.996 0 0 1-1.41 0Z" />
  </SvgIcon>
);

// Cancelled Icon
export const CancelledIcon = () => (
  <SvgIcon
    titleAccess="Cancelled"
    color="critical"
    size="xsmall"
    variant="solid"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20Zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9Z" />
  </SvgIcon>
);

// Unread Message Icon
export const UnreadMessageIcon = () => (
  <SvgIcon titleAccess="Unread message" color="critical" size="xsmall">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-.4 4.25-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25a.85.85 0 1 1 .9-1.44L12 11l6.7-4.19a.85.85 0 1 1 .9 1.44Z" />
  </SvgIcon>
);

// Read Message Icon
export const ReadMessageIcon = (props: SvgIconProps) => (
  <SvgIcon
    titleAccess="Message read"
    color={props.color ? props.color : "neutral"}
    size="xsmall"
  >
    <path d="M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10Zm-2 0v.01L12 13 4 8l8-4.68L19.99 8ZM4 18v-7.66l8 5.02 7.99-4.99L20 18H4Z" />
  </SvgIcon>
);

export const DeleteIcon = () => (
  <SvgIcon titleAccess="Delete" color="neutral">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10ZM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1Zm6.5-5-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5Z" />
  </SvgIcon>
);

export const CalculatorIcon = () => (
  <SvgIcon titleAccess="Gas appliance load calculator" color="neutral">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm0 16h14V5H5v14ZM6.25 7.72h5v1.5h-5v-1.5ZM18 15.75h-5v1.5h5v-1.5Zm-5-2.5h5v1.5h-5v-1.5ZM8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2v2Zm7.5-8.46-1.41 1.41-1.06-1.06 1.41-1.42-1.41-1.41L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.42-1.06 1.06-1.41-1.41Z"
    />
  </SvgIcon>
);

// Icons from playroom ends here
